<template>
  <div class="development-house-types-component mt-0" ref="wrapper">
    <p class="text-cg text-16">
      Choose the house types available
    </p>

    <div class="row">
      <div class="col-12 col-md-12">
        <div class="form-group">
          <label for="search">Add House Types</label>
          <input
            v-model="search"
            @keyup="getHouseTypes()"
            @change="getHouseTypes()"
            type="text"
            class="form-control"
            placeholder="Search house types..."
          />
          <ul
            v-if="availableHouseTypes.length > 0"
            class="mt-2 list-group list-group-flush"
          >
            <li
              v-for="houseType in availableHouseTypes"
              :key="houseType.id"
              class="
                list-group-item
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <span>{{ houseType.name }} <span v-if="houseType.revision" class="text-muted">({{
                  houseType.revision
                }})</span></span>
              <span>Bedrooms: {{ houseType.bedrooms }}</span>
              <span>Bathrooms: {{ houseType.bathrooms }}</span>
              <button
                @click="addHouseType(houseType.id)"
                type="button"
                class="ms-2 btn btn-success btn-sm"
              >
                +
              </button>
            </li>
          </ul>
          <small v-else class="text-muted d-block mt-3"
          >No house types found.</small
          >
        </div>
      </div>
      <div class="col-12 col-md-12">
        <div class="form-group">
          <label>Added House Types</label>
          <div class="developments-table" v-if="addedHouseTypes">
            <div class="development border mb-2" v-for="houseType in addedHouseTypes"
                 :key="houseType.id">
              <div class="row">
                <div class="col col-md-5 ps-0">
                  <div class="d-flex align-items-center position-relative"><img
                    :src="'/storage/'+houseType.image "
                    alt="Brook Meadow" width="160" height="120" class="development__image object-fit-cover"> <h5
                    class="mb-0 development__title">{{ houseType.name }} <br> <small>ID:
                    {{ houseType.development_house_type_id }}</small></h5></div>
                </div>
                <div class="col-12 col-md-3  border-left-0 d-flex align-items-center">
                  <div class="custom-control custom-checkbox ms-2 mb-2">
                    <input @change="updateAddedHouseTypes" v-model.number="houseType.hide_from_exp_centres"
                           type="checkbox" class="custom-control-input" :id="'hide-from-exp-centres-' + houseType.id"
                           :value="1">
                    <label class="custom-control-label" :for="'hide-from-exp-centres-' + houseType.id">Hide From Exp
                      Centres?</label>
                  </div>

                  <div>
                    <a
                      :href="'/admin/developments/' + developmentId + '/extras/' + houseType.id"
                      class="ms-2 btn btn-primary d-flex align-items-center justify-content-between btn-sm mb-1"
                    >
                      Pricing <i class="far fa-pencil ms-3"></i></a
                    >

                    <a
                      :href="'/admin/developments/' + developmentId + '/house-type/' + houseType.id + '/edit'"
                      class="ms-2 btn btn-secondary d-flex align-items-center justify-content-between btn-sm"
                    >
                      Edit <i class="far fa-pencil ms-3"></i></a
                    >
                  </div>
                </div>
                <div class="col-12 col-md">
                  <div class="d-flex align-items-center justify-content-center  h-100 position-relative"><h5
                    class="mb-0 text-center development__stat">
                    {{ houseType.bedrooms }}<br> <small>Bedrooms</small></h5>
                  </div>
                </div>
                <div class="col-12 col-md">
                  <div class="d-flex align-items-center justify-content-center h-100 position-relative"><h5
                    class="mb-0 text-center development__stat">
                    {{ houseType.bathrooms }}<br> <small>Bathrooms</small></h5>
                  </div>
                </div>
                <div class="col flex-grow-0 p-0">
                  <div
                    class="d-flex align-items-center justify-content-center flex-column h-100 position-relative development__actions development__actions--single">
                    <a
                      href="#" class="development__edit" @click="removeHouseType(houseType.id)">
                      <i class="fas fa-times"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="loading" class="mt-4 spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: null,
      availableHouseTypes: [],
      addedHouseTypes: [],
    };
  },

  props: {
    developmentId: {
      type: Number,
      default: null,
    },
  },

  watch: {
    loading: function (newValue, oldValue) {
      if (newValue) {
        $(this.$refs.wrapper)
          .closest("form")
          .find("button[type=submit]")
          .attr("disabled", true);
      } else {
        $(this.$refs.wrapper)
          .closest("form")
          .find("button[type=submit]")
          .attr("disabled", false);
      }
    },
  },

  created() {
    this.getHouseTypes();
  },

  methods: {
    getHouseTypes() {
      this.loading = true;
      this.availableHouseTypes = [];
      this.addedHouseTypes = [];

      axios
        .post(
          window.api_url +
          "/admin/developments/house_types/" +
          this.developmentId,
          {
            search: this.search,
          }
        )
        .then((res) => {
          this.availableHouseTypes = res.data.available_house_types;
          this.addedHouseTypes = res.data.added_house_types;
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    addHouseType(houseTypeId) {
      axios
        .post(
          window.api_url +
          "/admin/developments/add_house_type/" +
          this.developmentId +
          "/" +
          houseTypeId,
          {
            search: this.search,
          }
        )
        .then((res) => {
          this.availableHouseTypes = res.data.available_house_types;
          this.addedHouseTypes = res.data.added_house_types;
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    removeHouseType(houseTypeId) {
      axios
        .post(
          window.api_url +
          "/admin/developments/remove_house_type/" +
          this.developmentId +
          "/" +
          houseTypeId,
          {
            search: this.search,
          }
        )
        .then((res) => {
          this.availableHouseTypes = res.data.available_house_types;
          this.addedHouseTypes = res.data.added_house_types;
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateAddedHouseTypes() {
      axios
        .post(
          window.api_url +
          "/admin/developments/update_added_house_types/" +
          this.developmentId,
          {
            added_house_types: this.addedHouseTypes,
          }
        )
        .then((res) => {
          //
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
